import ImgTopLanguage from '../../../assets/image/report/img_banner_top_language.png';
import ImgMid1 from '../../../assets/image/report/img_banner_middle_1.png';
import ImgMid2 from '../../../assets/image/report/img_banner_middle_2.png';
import ImgBottom from '../../../assets/image/report/img_banner_bottom.png';
import TitleText from '../../common/TitleText';
import DotText from '../../common/DotText';
import Text from '../../common/Text';
import TitleDotText from '../../common/TitleDotText';
import { useTranslation } from '../../../hook/useTranslation';

function Language() {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-start justify-start gap-[40px]">
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgTopLanguage} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.definition')} />
        <Text text={t('report.language.definition')} />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgMid1} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.behavioral_characteristics', { age: 7 })} />
        <DotText text={t('report.language.behavior.1')} />
        <DotText text={t('report.language.behavior.2')} />
        <DotText text={t('report.language.behavior.3')} />
        <DotText text={t('report.language.behavior.4')} />
        <DotText text={t('report.language.behavior.5')} />
        <DotText text={t('report.language.behavior.6')} />
        <DotText text={t('report.language.behavior.7')} />
        <DotText text={t('report.language.behavior.8')} />
        <DotText text={t('report.language.behavior.9')} />
        <DotText text={t('report.language.behavior.10')} />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgMid2} alt="top" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.support_method')} />
        <TitleDotText
          title={t('report.language.support.1.title')}
          text={t('report.language.support.1.desc')}
        />
        <TitleDotText
          title={t('report.language.support.2.title')}
          text={t('report.language.support.2.desc')}
        />
        <TitleDotText
          title={t('report.language.support.3.title')}
          text={t('report.language.support.3.desc')}
        />
        <TitleDotText
          title={t('report.language.support.4.title')}
          text={t('report.language.support.4.desc')}
        />
        <TitleDotText
          title={t('report.language.support.5.title')}
          text={t('report.language.support.5.desc')}
        />
      </div>
      <div className="w-full flex justify-start items-center gap-2">
        <img src={ImgBottom} alt="ImgBottom" className="w-full h-[272px] object-cover" />
      </div>
      <div className="w-full px-[20px]">
        <TitleText text={t('report.detail.precautions')} />
        <Text text={t('report.language.precautions')} />
      </div>
      <div>&nbsp;</div>
    </div>
  );
}

export default Language;
